import type { AuthRepository } from '@core/repositories/AuthRepository';

export class ForgotPasswordUseCase {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  execute(email: string): Promise<void> {
    return this.authRepository.forgotPassword(email);
  }
}
